import script from "./UndoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UndoButton.vue?vue&type=script&setup=true&lang=js"

import "./UndoButton.vue?vue&type=style&index=0&id=424dd734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424dd734"]])

export default __exports__